// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__8sYzZ","errorLogs":"EditorFooter_errorLogs__iTDK1"};